import { Component, OnInit } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';

@Component({
  selector: 'app-home-gallery',
  templateUrl: './home-gallery.component.html',
  styleUrls: ['./home-gallery.component.scss']
})
export class HomeGalleryComponent implements OnInit {
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  constructor() { }

  ngOnInit(): void {
    // this.galleryOptions = [
    //   { 
    //     width: '600px',
    //     height: '400px',
    //     "thumbnailsColumns": 3, 
    //     "thumbnailsRows": 2, 
    //     "thumbnailsPercent": 40, 
    //     "imagePercent": 60, 
    //     "thumbnailMargin": 2, 
    //     "thumbnailsMargin": 2, 
    //     "thumbnailsOrder": 2 
    //   },
    //   { 
    //     "breakpoint": 800, 
    //     "width": "100%", 
    //     "height": "300px", 
    //     "thumbnailsColumns": 3 
    //   },
    //   { 
    //     "breakpoint": 300, 
    //     "width": "100%", 
    //     "height": "200px", 
    //     "thumbnailsColumns": 2 
    //   }
    // ];

    this.galleryOptions = [
      {
        width: '95%',
        height: '400px',
        thumbnailsColumns: 5,
        imageAnimation: NgxGalleryAnimation.Slide,
        previewCloseOnClick: true,
        previewCloseOnEsc: true,
        previewKeyboardNavigation: true,
      },
      // max-width 800
      {
        breakpoint: 800,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
      },
      // { 
      //   "breakpoint": 800, 
      //   "width": "100%", 
      //   "height": "300px", 
      //   "thumbnailsColumns": 4 
      // },
      // { 
      //   "breakpoint": 300, 
      //   "width": "100%", 
      //   "height": "200px", 
      //   "thumbnailsColumns": 4 
      // }
      // max-width 400
      // {
      //   breakpoint: 400,
      //   preview: false
      // }
    ];



    
    this.galleryImages = [
      {
        small: '/assets/img/home/small/1010-1 The After School.jpg',
        medium: '/assets/img/home/large/1010-1 The After School.jpg',
        big: '/assets/img/home/large/1010-1 The After School.jpg'
      },
      {
        small: '/assets/img/home/small/1020-2-The Ambassador.jpg',
        medium: '/assets/img/home/large/1020-2-The Ambassador.jpg',
        big: '/assets/img/home/large/1020-2-The Ambassador.jpg'
      },
      {
        small: "/assets/img/home/small/1030-2 Santas Favorite.jpg",
        medium: "/assets/img/home/large/1030-2 Santas Favorite.jpg",
        big: "/assets/img/home/large/1030-2 Santas Favorite.jpg"
      },
      {
        small: '/assets/img/home/small/2020-1 The Lorax.jpg',
        medium: '/assets/img/home/large/2020-1 The Lorax.jpg',
        big: '/assets/img/home/large/2020-1 The Lorax.jpg'
      },
      {
        small: "/assets/img/home/small/1030-2 Santas Favorite.jpg",
        medium: "/assets/img/home/large/1030-2 Santas Favorite.jpg",
        big: "/assets/img/home/large/1030-2 Santas Favorite.jpg"
      },
      
    ];
}

}



// WEBPACK FOOTER //
// ./src/app/components/home/home-gallery/home-gallery.component.ts